import script from "./Nyhongshu.vue?vue&type=script&setup=true&lang=js"
export * from "./Nyhongshu.vue?vue&type=script&setup=true&lang=js"

import "./Nyhongshu.vue?vue&type=style&index=0&id=1ff348be&lang=less&scoped=true"
script.__scopeId = "data-v-1ff348be"

export default script